import Cookies from 'js-cookie';

export default (status) => ({
  enabled: status,
  init() {
    if (this.enabled) {
      if (typeof Cookies.get('podcast-ticker') === 'undefined') {
        Cookies.set('podcast-ticker', 'ticked');
        document.body.classList.add('podcast-ticker-enabled');
      } else {
        this.enabled = false;
      }
    }
  },
});
